// extracted by mini-css-extract-plugin
export var completionBody = "_lp-2";
export var completionCard = "_lp-0";
export var completionFooter = "_lp-3";
export var completionTitle = "_lp-1";